const estimatedDeliveryCount = () => {
    const estimated_days = window.estimatedDelivery.days;
    const estimated_text_el = document.querySelector('.product__delivery span') 

    if(estimated_days) {
        const intital_day = Number(estimated_days.split('to')[0])
        const ending_day = Number(estimated_days.split('to')[1]);

        let currentDateforIntital = new Date(); // current date;
        let currentDateforEnding = new Date(); // current date;

        const hours = String(new Date().getHours()).padStart(2, '0');
        const minutes = String(new Date().getMinutes()).padStart(2, '0');

        if(hours >= 18 && minutes > 0) {
            currentDateforIntital.setDate(currentDateforIntital.getDate() + 1);
            currentDateforEnding.setDate(currentDateforEnding.getDate() + 1);
        }

        // Add intital day to the current date
        currentDateforIntital.setDate(currentDateforIntital.getDate() + intital_day);
        currentDateforEnding.setDate(currentDateforEnding.getDate() + ending_day);
  
        if(currentDateforIntital.getDay() == 0) {
            currentDateforIntital.setDate(currentDateforIntital.getDate() + 1);
            currentDateforEnding.setDate(currentDateforEnding.getDate() + 1);
        } else if(currentDateforEnding.getDay() == 0) {
            currentDateforEnding.setDate(currentDateforEnding.getDate() + 1);
        }
        const intial_delivery_date = currentDateforIntital.getDate();
        const ending_delivery_date = currentDateforEnding.getDate();
        
        const monthNames = [
            'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul',
            'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
        ];

        const dayNames = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat']
          
        const intial_delivery_month = monthNames[currentDateforIntital.getMonth()];
        const ending_delivery_month = monthNames[currentDateforEnding.getMonth()];
        const intial_delivery_day = dayNames[currentDateforIntital.getDay()];
        const ending_delivery_day = dayNames[currentDateforEnding.getDay()];

        if(estimated_text_el) {
            // estimated_text_el.innerHTML = `${intial_delivery_month} ${intial_delivery_date} (${intial_delivery_day}) - ${ending_delivery_month} ${ending_delivery_date} (${ending_delivery_day})`;
            estimated_text_el.innerHTML = "Select your preferred Delivery Date during checkout"
        }
    }
}


estimatedDeliveryCount()